<template>
  <div>
    <label style="color:grey;">{{ fieldLabel }}</label>

    <v-radio-group
      v-model="extraFieldsValue.value"
    >
      <v-radio
        v-for="(opt, checkI ) in options"
        :key="checkI"
        :label="opt"
        :value="opt"
      />
      <template/>
    </v-radio-group>

  </div>
</template>
<script>
export default {
  name: 'Radio',
  props: {
    isrequired: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    extraFieldsValue: {
      type: Object,
      default: () => { return {} }
    },
    options: {
      type: Array,
      default: () => { return {} }
    }
  }

}
</script>
